import { useEffect } from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import UserTransmissionProgressAnalyticChart from "./chart/UserTransmissionProgressAnalyticChart";
import UserFilter from "./filters/userFilter";
import useUserTransmissionProgressAnalytic from "./hooks/useUserTransmissionProgressAnalytic";
import Loading from "components/common/loading/Loading";
import DateRangeFilter from "./filters/dateRangeFilter";
import { showErrorToast } from "utils/toast";

const UserTransmissionProgressAnalytic = () => {
  const {
    selectedUserIds,
    setSelectedUserIds,
    users,
    startDate,
    endDate,
    isFetching,
    chartOptions,
    handleStartDateChange,
    handleEndDateChange,
    prepareChartData,
    error,
    isError,
    isFetchUsersError,
    fetchUsersError,
  } = useUserTransmissionProgressAnalytic();

  useEffect(() => {
    isError &&
      showErrorToast(error?.message || "An error occurred. Please try again.");
  }, [isError]);

  useEffect(() => {
    isFetchUsersError &&
      showErrorToast(
        fetchUsersError?.message || "An error occurred. Please try again."
      );
  }, [isFetchUsersError]);

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              User Transmission Progress Analytics
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {users?.length > 0 && (
              <UserFilter
                selectedUserIds={selectedUserIds}
                setSelectedUserIds={setSelectedUserIds}
                users={users}
              />
            )}

            <DateRangeFilter
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
            />
          </Grid>
        </Grid>
        {isFetching ? (
          <Loading height="300px" />
        ) : (
          <Grid container item flex={1}>
            <UserTransmissionProgressAnalyticChart
              options={chartOptions}
              prepareChartData={prepareChartData}
            />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default UserTransmissionProgressAnalytic;
